require('./RAHireFundTable.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const Immutable = require('immutable');

// @commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @components
const RAOneLineSymbolAmount = require('../RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const RAHireFundRow = require('./RAHireFundRow');

// @constants
const { BROKER_TRANSFER_FUNDS_ALL } = require('constants/index');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

class RAHireFundTable extends React.Component {
    constructor(props) {
        super(props);
        this.handleHireFundChange = this.handleHireFundChange.bind(this);
    }
    buildTableHeader() {
        return (
            <thead>
                <OKTableRow className="ra-hire-fund-table__header-row">
                    <OKTableCell
                        className="ra-hire-fund-table__header-row-associated"
                        asHeader={true}
                    >
                        <FormattedText
                            value="raHireManagementPlanStep1-raHireManagementPlanStep1_associatedFunds"
                            format="uppercase"
                        />
                    </OKTableCell>
                    <OKTableCell
                        className="ra-hire-fund-table__header-row-rentability"
                        asHeader={true}
                    >
                        <FormattedText
                            value="raHireManagementPlanStep1-raHireManagementPlanStep1_rentability"
                            format="uppercase"
                        />
                    </OKTableCell>
                    <OKTableCell
                        className="ra-hire-fund-table__header-row-units"
                        asHeader={true}
                    >
                        <FormattedText
                            value="raHireManagementPlanStep1-raHireManagementPlanStep1_units"
                            format="uppercase"
                        />
                    </OKTableCell>
                    <OKTableCell
                        className="ra-hire-fund-table__header-row-amount"
                        asHeader={true}
                    >
                        <FormattedText
                            value="raHireManagementPlanStep1-raHireManagementPlanStep1_actualAmount"
                            format="uppercase"
                        />
                    </OKTableCell>
                </OKTableRow>
            </thead>
        );
    }

    handleHireFundChange(checked, contractNumber, accountId, amount) {
        const {
            fundsTotalAmount,
            selectedAccountsWithFunds,
            updateSelectedAccountsWithFunds,
            updateSelectedFundsTotal,
        } = this.props;
        let newSelectedAccountWithFunds = selectedAccountsWithFunds;
        let newTotals;
        if (checked) {
            const accountIdExists =
                selectedAccountsWithFunds &&
                selectedAccountsWithFunds.get(accountId);
            if (!accountIdExists) {
                newSelectedAccountWithFunds = newSelectedAccountWithFunds.set(
                    accountId,
                    Immutable.List(),
                );
            }
            updateSelectedAccountsWithFunds(
                accountId,
                newSelectedAccountWithFunds.set(
                    accountId,
                    newSelectedAccountWithFunds
                        .get(accountId)
                        .push(contractNumber),
                ),
            );
            newTotals = fundsTotalAmount + amount;
            updateSelectedFundsTotal(newTotals);
        } else {
            const contractNumberIndex = newSelectedAccountWithFunds
                .get(accountId)
                .indexOf(contractNumber);
            newTotals = fundsTotalAmount - amount;
            updateSelectedFundsTotal(newTotals);
            updateSelectedAccountsWithFunds(
                accountId,
                newSelectedAccountWithFunds.removeIn(
                    [accountId, contractNumberIndex],
                    contractNumber,
                ),
            );
        }
    }

    buildItemsRow(account) {
        const {
            selectedAccountsWithFunds,
            showDetails,
            filterSelectedAccounts,
        } = this.props;
        let availableFunds = account.get('funds');
        const accountId = account.get('accountId');
        if (filterSelectedAccounts) {
            availableFunds = availableFunds.filter(
                immFund =>
                    selectedAccountsWithFunds
                        .get(accountId)
                        .indexOf(immFund.get('contractNumber')) !== -1,
            );
        }
        return availableFunds.entrySeq().map(entry => {
            const fund = entry[1];
            const selectedAccounts = showDetails
                ? selectedAccountsWithFunds.get(accountId)
                : null;
            const isChecked =
                !!selectedAccounts &&
                selectedAccounts.some(
                    contractNumber =>
                        contractNumber === fund.get('contractNumber'),
                );
            const isFundDisabled =
                selectedAccountsWithFunds.size === 20 && !isChecked;
            return (
                <RAHireFundRow
                    key={accountId + fund.get('contractNumber')}
                    accountId={accountId}
                    item={fund}
                    hasCheckBox={showDetails}
                    disabledRow={isFundDisabled}
                    onUpdateCheckbox={this.handleHireFundChange}
                    statusCheckbox={isChecked}
                />
            );
        });
    }

    buildTableBody() {
        const {
            selectedAccount,
            selectedAccountsWithFunds,
            filterSelectedAccounts,
            availableAccountsWithFunds,
        } = this.props;
        let immSelectedAccounts = availableAccountsWithFunds;
        if (selectedAccount !== BROKER_TRANSFER_FUNDS_ALL) {
            immSelectedAccounts = availableAccountsWithFunds.filter(
                immAccount => immAccount.get('accountId') === selectedAccount,
            ); // required to filter selected accounts
        }

        if (filterSelectedAccounts) {
            immSelectedAccounts = immSelectedAccounts.filter(
                immAccount =>
                    !!selectedAccountsWithFunds.get(
                        immAccount.get('accountId'),
                    ),
            );
        }

        return immSelectedAccounts.entrySeq().map((entry, index) => {
            const items = entry[1];
            if (items.size === 0) {
                return null;
            }
            const rows = this.buildItemsRow(items);
            return <tbody key={index}>{rows}</tbody>;
        });
    }

    buildTableFooter(totalAmount, formattedSimulationAmount) {
        const formattedAmount = {
            amount: totalAmount,
            currency: 'EUR',
        };
        return (
            <div className="ra-hire-fund-table__footer-row">
                <FormattedText
                    className="ra-hire-fund-table__simulation-label"
                    value="raHireManagementPlanStep1-raHireManagementPlanStep1_simulationAmountLabel"
                />
                <RAOneLineSymbolAmount
                    amountObject={formattedSimulationAmount}
                />
                <div className="ra-hire-fund-table__footer-wrapper">
                    <div className="ra-hire-fund-table__total-amount">
                        <RAOneLineSymbolAmount amountObject={formattedAmount} />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            fundsTotalAmount,
            simulationAmount,
            showDetails,
            showFooterOnly,
        } = this.props;
        const formattedAmount = {
            amount: simulationAmount,
            currency: 'EUR',
        };
        const headerContent = this.buildTableHeader();
        const bodyContent = this.buildTableBody();
        const footerContent =
            showDetails || showFooterOnly
                ? this.buildTableFooter(fundsTotalAmount, formattedAmount)
                : null;
        let tableClass = 'ra-hire-fund-table';
        const totalFundsLabelKey =
            'raHireManagementPlanStep1-raHireManagementPlanStep1_totalFundsSelected';
        let bottomGradient;
        let footerDescription;
        if (showDetails) {
            tableClass = 'ra-hire-fund-table__container';
            bottomGradient = (
                <div className="ra-hire-fund-table__bottom-gradient-section" />
            );
            footerDescription = (
                <div className="ra-hire-fund-table__footer-description">
                    <div className="ra-hire-fund-table__footer-amount">
                        <FormattedText value={totalFundsLabelKey} />
                    </div>
                </div>
            );
        }
        return (
            <section>
                <div className={tableClass}>
                    <OKTable>
                        {headerContent}
                        {bodyContent}
                    </OKTable>
                </div>
                {bottomGradient}
                {footerContent}
                {footerDescription}
            </section>
        );
    }
}

RAHireFundTable.propTypes = {
    accountOwner: PropTypes.string,
    availableAccountsWithFunds: PropTypes.object.isRequired,
    filterSelectedAccounts: PropTypes.bool,
    fundsTotalAmount: PropTypes.number,
    selectedAccount: PropTypes.string.isRequired,
    selectedAccountsWithFunds: PropTypes.object.isRequired,
    showAccountHeader: PropTypes.bool,
    showDetails: PropTypes.bool,
    showFooterOnly: PropTypes.bool,
    simulationAmount: PropTypes.number,
    updateSelectedAccountsWithFunds: PropTypes.func,
    updateSelectedFundsTotal: PropTypes.func,
};

RAHireFundTable.defaultProps = {
    showAccountHeader: true,
    showDetails: false,
    filterSelectedAccounts: false,
};

module.exports = RAHireFundTable;
